import { render, staticRenderFns } from "./index.vue?vue&type=template&id=0ecf5e9f&scoped=true&"
import script from "./index.vue?vue&type=script&lang=js&"
export * from "./index.vue?vue&type=script&lang=js&"
import style0 from "./index.vue?vue&type=style&index=0&id=0ecf5e9f&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0ecf5e9f",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/lib/jenkins/workspace/manage.pc.frontend-purchase-test/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0ecf5e9f')) {
      api.createRecord('0ecf5e9f', component.options)
    } else {
      api.reload('0ecf5e9f', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=0ecf5e9f&scoped=true&", function () {
      api.rerender('0ecf5e9f', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/general/association/modules/addConfig/index.vue"
export default component.exports